import { updateField, getField } from 'vuex-map-fields'
import api from '../api'

const state = {

	messages: {
		data: [],
		current_page: 0,
		last_page: 0
	},
	messagesLoading: false,

	selectedIndex: 0,
	selectedMessage: {
		id: 0,
		name: '',
		time_created: '',
		date_created: '',
		type: '',
		email: '',
		reply: ''
	},

	reply: '',
	buttonLoading: false,

	notifications: {
		data: [],
		current_page: '',
		last_page: ''
	},
	notificationLoading: false,
	unreadNotificationCount: 0,

	emailList: [],
	emailListLoading: false,

	email: {
		subject: '',
		message: ''
	},

	selectedEmails: [],
	tempFiles: [],
	attachments: [],
	deletedAttachments: [],

	unseenCount: null
}

const mutations = {
	updateField,

	clearCompose (state) {
		state.email = {
			subject: '',
			message: ''
		}
		state.reply = ''
		state.selectedEmails = []
		state.tempFiles = []
		state.attachments = []
		state.deletedAttachments = []
	},

	clearSelectedMessage (state) {
		state.selectedMessage = {
			id: 0,
			name: '',
			time_created: '',
			date_created: '',
			type: '',
			email: '',
			reply: ''
		}
	}
}

const actions = {
	async send ({ state, commit, dispatch }, payload) {
		state.buttonLoading = true

		const { status } = await api('post', 'message/send-message', payload)

		if (status) {
			dispatch('toggleBanner', {
				status: true,
				message: 'Email sent',
				type: 'success'
			}, { root: true })
			commit('clearCompose')
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async getList ({ state }, payload) {
		state.messagesLoading = true

		const { data, status } = await api('get', `message/list${payload}`)

		if (status) {
			state.messages.data = [...state.messages.data, ...data.data.data]
			state.messages.current_page = data.data.current_page
			state.messages.last_page = data.data.last_page

			state.messagesLoading = false
			return
		}

		state.messagesLoading = false
	},

	async getSent ({ state }, payload) {
		state.messagesLoading = true

		const { data, status } = await api('get', `message/sent-message?keyword=${payload}`)

		if (status) {
			state.messages.data = [...state.messages.data, ...data.data.data]
			state.messages.current_page = data.data.current_page
			state.messages.last_page = data.data.last_page

			state.messagesLoading = false
			return
		}

		state.messagesLoading = false
	},

	async sendReply ({ state, commit, dispatch }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('post', 'message/reply', payload)

		if (status) {
			state.selectedMessage.reply = data.data.message
			dispatch('toggleBanner', {
				status: true,
				message: 'Email sent',
				type: 'success'
			}, { root: true })
			commit('clearCompose')
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async getNotificationList ({ state }, payload) {
		state.notificationLoading = true

		const { data, status } = await api('get', `message/notification-list?page=${payload}`)

		if (status) {
			state.notifications.current_page = data.data.current_page
			state.notifications.last_page = data.data.last_page
			state.notifications.data = [state.notifications.data, ...data.data]
			state.unreadNotificationCount = data.data.status
			state.notificationLoading = false
			return
		}

		state.notificationLoading = false
	},

	async getEmailList ({ state }, payload) {
		state.emailListLoading = true

		const { data, status } = await api('post', `message/email-search?keyword=${payload}`)

		if (status) {
			state.emailList = data.data
			state.emailListLoading = false
			return
		}

		state.emailListLoading = false
	},

	async seenMessage ({ state }, payload) {
		const { data, status } = await api('post', 'message/seen-message', payload.form)

		if (status) {
			payload.message.seen = data.data.seen
		}
	},

	async tempUpload ({ state }, payload) {
		state.buttonLoading = true
		const { data, status } = await api('post', 'global/temp-upload', payload)

		if (!(status && data.status === 200)) {
			state.buttonLoading = false
			return
		}

		state.tempFiles.push(data.data)
		state.buttonLoading = false
	},

	async addAttachment ({ state, dispatch }, payload) {
		state.buttonLoading = true
		const { data, status } = await api('post', 'global/temp-upload', payload)

		if (!(status && data.status === 200)) {
			dispatch('toggleBanner', {
				status: true,
				message: data.errors.file[0],
				type: 'invalid'
			}, { root: true })
			state.buttonLoading = false
			return
		}

		state.attachments.push(data.data)
		state.buttonLoading = false
	},

	async discard ({ state, commit, dispatch }, payload) {
		state.buttonLoading = true
		const { data, status } = await api('post', 'message/discard-message', payload.form)

		if (!(status && data.status === 200)) {
			state.buttonLoading = false
		}

		commit('clearCompose')
		if (payload.changePage) {
			dispatch('clearData')
			payload.callback()
		}
		state.buttonLoading = false
	},

	async getCount ({ state, commit }, payload) {
		const { data, status } = await api('get', `message/list-count`)
		if (status && data.status === 200) state.unseenCount = data.data
	},

	clearData ({ state }) {
		state.messages = {
			data: [],
			current_page: 0,
			last_page: 0
		}

		state.selectedIndex = 0
		state.selectedMessage = {
			id: 0,
			name: '',
			time_created: '',
			date_created: '',
			type: '',
			email: '',
			reply: ''
		}

		state.selectedEmails = []
		state.tempFiles = []
	}
}

const getters = {
	getField,
	getList: state => state.messages,
	getListLoading: state => state.messagesLoading
}

export default {
	state,
	namespaced: true,
	mutations,
	actions,
	getters
}
